<template>
  <div class="contai_h">
    <!-- 数据看板 -->
    <div class="cont_tops">
      <div class="con_query">
        <div class="con_ins">
          <el-input class="inps" placeholder="请输入当户名字"  prefix-icon="el-icon-search" v-model="inpsearch">
        </el-input>
        <el-button type="primary" icon="el-icon-search" @click="namesearch">搜索</el-button>
        </div>
        <div class="con_ins">
            <el-input class="inps" placeholder="请输入当票号"  prefix-icon="el-icon-search" v-model="inpsearchs">
        </el-input>
        <el-button type="primary" icon="el-icon-search" @click="pnums">搜索</el-button>
        </div>
        
      </div>

      <div class="cont_box">
        <div class="cont_o">
          <h2>今日赎回：{{ taylength }}</h2>
          <h3>赎回金额：{{ tayprice + '元'}}</h3>
        </div>
        <div class="cont_o">
           <h2>已赎回业务：{{ yredeem }}</h2>
          <h3>赎回金额：{{ price + '元'}}</h3>
        </div>
      </div>
    </div>

    <!-- 内容主体 -->
    <div class="cont_cont">
      <el-tabs type="border-card" closable>
        <!-- 已赎回订单 -->
        <el-tab-pane label="已赎回订单">
    <el-table
    :data="items"
    border
    style="width: 100%">
     <el-table-column
      prop="state"
      label="典当状态">
    </el-table-column>
    <el-table-column
      prop="deta"
      label="建当日期"
      width="150">
    </el-table-column>
    <el-table-column
      prop="name"
      label="姓名"
      width="90">
    </el-table-column>
    <el-table-column
      prop="ticketnumber"
      label="票号"
      width="110">
    </el-table-column>
    <el-table-column
      prop="telnumber"
      label="联系电话"
      width="120">
    </el-table-column>
    <el-table-column
      prop="objname"
      label="典当物品"
      width="120">
    </el-table-column>
    <el-table-column
      prop="number"
      label="数量">
    </el-table-column>
     <el-table-column
      prop="weight"
      label="重量">
    </el-table-column>
    <el-table-column
      prop="price"
      label="典当金额">
    </el-table-column>
    <el-table-column
      prop="startdate"
      label="开始日期"
      width="130">
    </el-table-column>
    <el-table-column
      prop="enddate"
      label="结束日期"
      width="130">
    </el-table-column>
    <el-table-column
      prop="days"
      label="典当天数">
    </el-table-column>
    <el-table-column
      prop="cost"
      label="典当综合费">
    </el-table-column>
    <el-table-column
      prop="lx"
      label="典当利息">
    </el-table-column>
    <el-table-column
      prop="agent"
      label="经办人">
    </el-table-column>
    <el-table-column
      prop="review"
      label="复核人">
    </el-table-column>
     <el-table-column
      prop="finance"
      label="财务">
      </el-table-column>

      <el-table-column
      fixed="right"
      label="操作"
      width="130">
      <template slot-scope="scope">
        <el-button @click="handleClicks(scope.row._id)" type="primary" size="small">查看详情</el-button>
      </template>
    </el-table-column> -->
      </el-table>

        </el-tab-pane>
      </el-tabs>


      <!-- 分页 -->
      <el-pagination
        background
        layout="prev, pager, next"
        :total="yredeem"
        :page-size="100"
        class="fs"
        @current-change="paging"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
export default {
  name: "redeemed",

  data() {
    return {
      ACCESS_TOKEN: "", //ACCESS_TOKEN
      yredeem: 0, //所有已赎回的订单数
      items: [], //所有逾期订单的数据
      price: "", //所有逾期的总金额
      deta: "", //今天的日期
      day: "", //逾期界定日期
      sid: "", //赎回的id
      inpsearch:"", //搜索名字输入框的值
      inpsearchs:"", //搜索证件号码的值 
      taylength:0,   //今天赎回的数量
      tayprice:0   //今日赎回的总金额
    };
  },

  components: {},

  // 逻辑方法
  methods: {
    //查看赎回
    handleClicks(e) {
      let id = e;
      this.$router.push({ path: "/details", query: { id: id } });
    },

    //请求今日赎回的数据
    getdy(){
      this.axios
      .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
        env: `${this.userData.env}`,
        query: `db.collection("yxus_record").where({xuday:"${this.deta}",stas:"赎当"}).get()`
      }).then(res=>{
         res.data.data.forEach((element, index, array) => {
          array[index] = JSON.parse(element);
        });
        this.taylength = res.data.pager.Total

        //循环计算今日赎回的总金额
        let str = "";
        for (let i in res.data.data) {
          str += res.data.data[i].pri;
          str += "+";
        }
        str = str.substring(0, str.length - 1);
        this.tayprice = eval(str) || 0;
      })

    },
    //请求所有赎回的数据
    getdatas(){
       //请求已赎回的总数量
    this.axios
      .post("/api/tcb/databasecount?access_token=" + this.ACCESS_TOKEN, {
        env: `${this.userData.env}`,
        query: 'db.collection("add_data").where({state:"赎回"}).count()',
      })
      .then((sulength) => {
       if(sulength.data.errcode !== 0){
         return this.$notify.error({
              title: '错误提示',
              message: '密钥过期啦，请刷新页面'
            });
       }
        this.yredeem = sulength.data.count; //今日赎回总数量
        
        let num = Math.ceil(sulength.data.count / 1000)
        this.SumPrice(num)
        

      });

    //请求已赎回数据
    this.axios
      .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
        env: `${this.userData.env}`,
        query: 'db.collection("add_data").where({state:"赎回"}).limit(100).get()',
      })
      .then((rs) => {
        rs.data.data.forEach((element, index, array) => {
          array[index] = JSON.parse(element);
        });


        //所有已赎回的订单日期排序
        function sortUpDate(ac, bc) {
          return Date.parse(bc.enddate) - Date.parse(ac.enddate);
        }
        this.items = rs.data.data.sort(sortUpDate);

        //循环计算赎回的总金额
        let str = "";
        for (let i in this.items) {
          str += this.items[i].price;
          str += "+";
        }
        str = str.substring(0, str.length - 1);
        this.price = eval(str);

      });
    },

    //计算总金额
    SumPrice(event){

        let priArr = []
      for(let i=0;i<event;i++){
        let num = i * 1000

         this.axios
          .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query: `db.collection("add_data").where({state:"赎回"}).limit(1000).skip(${num}).get()`,
          }).then(res=>{
            res.data.data.forEach((element,index,array)=>{
              array[index] = JSON.parse(element)
            })

            //循环计算赎回的总金额
        let str = "";
        for (let i in res.data.data) {
          str += res.data.data[i].price;
          str += "+";
        }
        str = str.substring(0, str.length - 1);
        let pri = eval(str) || 0;
        priArr.push(pri)



          //第二次计算和
          let strnum = "";
        for (let i in priArr) {
          strnum += priArr[i];
          strnum += "+";
        }
        strnum = strnum.substring(0, strnum.length - 1);
        this.price = eval(strnum) || 0
          
          })
        
      }
     
      
    },

    //分页点击事件
    paging(event) {
      let ae = event - 1;
      let pages = ae * 100;

      //分点击请求已赎回的数据
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query:
            'db.collection("add_data").where({state:"赎回"}).limit(100).skip(' +
            pages +
            ").get()",
        })
        .then((frs) => {
          frs.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          //所有已赎回的订单日期排序
          function sortUpDate(ac, bc) {
            return Date.parse(bc.deta) - Date.parse(ac.deta);
          }
          this.items = frs.data.data.sort(sortUpDate);

          //循环计算赎回的总金额
          let str = "";
          for (let i in this.items) {
            str += this.items[i].price;
            str += "+";
          }
          str = str.substring(0, str.length - 1);
          this.price = eval(str);
        });
    },
    //通过名字搜索数据
    namesearch(){
      //发请求请求赎回名字等于搜索的数据
     this.axios
      .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
        env: `${this.userData.env}`,
        query: 'db.collection("add_data").where({state:"赎回",name:"'+this.inpsearch+'"}).limit(1000).get()',
      }).then((rname)=>{
        rname.data.data.forEach((element, index, array) => {
          array[index] = JSON.parse(element);
        });
        this.items = rname.data.data
      })
    },

    //发请求通过证件号码搜索数据
      pnums(){
          this.axios
      .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
        env: `${this.userData.env}`,
        query: 'db.collection("add_data").where({state:"赎回",ticketnumber:"'+this.inpsearchs+'"}).limit(1000).get()',
      }).then((rcard)=>{
         rcard.data.data.forEach((element, index, array) => {
          array[index] = JSON.parse(element);
        });
        this.items = rcard.data.data
        })
      },
  },
  //   生命周期钩子函数--组件创建时
  created() {
    // this.ACCESS_TOKEN = localStorage.getItem("ACCESS_TOKEN"); //获取到this.ACCESS_TOKEN
       //获取到this.ACCESS_TOKEN
     this.getTokens()

     //获取当前登录的用户数据
    this.getUserToken()

    this.deta = dayjs().format("YYYY-MM-DD"); //今天的日期

    //逾期、绝当鉴定日期
    this.day = dayjs().subtract(6, "day").format("YYYY-MM-DD");


  },
  //   生命周期函数挂载完成时
  mounted() {
   setTimeout(()=>{
     this.getdatas()
      this.getdy()
   },800)
      
  },
};
</script>
<style scoped>
.cont_tops {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.cont_box {
  width: 40%;
  height: 180px;
  background-color: #ffffff;
  display: flex;
  flex-direction: row;
  /* justify-content: space-between; */
  align-items: center;
}
.con_query {
  width: 59%;
  background-color: #ffffff;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.cont_o {
  width: 350px;
  height: 120px;
  background-color: #22afd3;
  border-radius: 10px;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
  margin: 0 30px;
}

.cont_cont {
  width: 100%;
  background-color: #ffffff;
  margin: 20px auto;
}
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 33%;
}
.cont_img img {
  width: 650px;
  margin: 10px 30px;
}
.fs {
  margin: 15px auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.con_ins{
  width: 35%;
  display: flex;
flex-direction: row;
margin: 0 auto;
}
</style>
